module.exports = __webpack_public_path__ + "0dc76f3e9e3d6a06f72481d0dcd3340f.svg";